__turbopack_context__.v({
  "container": "NavnIdentHeader-module__Rd-BJq__container",
  "downloadButton": "NavnIdentHeader-module__Rd-BJq__downloadButton",
  "headerContent": "NavnIdentHeader-module__Rd-BJq__headerContent",
  "ident": "NavnIdentHeader-module__Rd-BJq__ident",
  "knapper": "NavnIdentHeader-module__Rd-BJq__knapper",
  "merkelapp": "NavnIdentHeader-module__Rd-BJq__merkelapp",
  "navnRad": "NavnIdentHeader-module__Rd-BJq__navnRad",
  "separator": "NavnIdentHeader-module__Rd-BJq__separator",
  "textRow": "NavnIdentHeader-module__Rd-BJq__textRow",
});
